import type { Feature } from '@exodus/dependency-types';

import pwaApiDefinition from './api.js';
import installCalloutVisibleAtomDefinition from './atoms/install-callout-visible.js';
import installModalVisibleAtomDefinition from './atoms/install-modal-visible.js';
import pwaPluginDefinition from './plugin.js';

const storage = { namespace: 'pwa' };

const pwa = () =>
  ({
    id: 'pwa',
    definitions: [
      { definition: pwaApiDefinition, storage },
      { definition: pwaPluginDefinition },
      {
        definition: installCalloutVisibleAtomDefinition,
        storage,
      },
      {
        definition: installModalVisibleAtomDefinition,
        storage,
      },
    ],
  }) satisfies Feature;

export default pwa;
